module.exports = __webpack_public_path__ + "static/media/claro-logo.90fad45d.png";